module.exports = __webpack_public_path__ + "img/D54C2B_5F1105_F39382_F08375-256px.4a292321.png";